import { render, staticRenderFns } from "./FlexChildrenOverflowedText.vue?vue&type=template&id=be2add06&"
import script from "./FlexChildrenOverflowedText.vue?vue&type=script&lang=js&"
export * from "./FlexChildrenOverflowedText.vue?vue&type=script&lang=js&"
import style0 from "./FlexChildrenOverflowedText.vue?vue&type=style&index=0&id=be2add06&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports